import Backbone from 'backbone'
import template from './labeled-toggle.hbs'
import $ from 'jquery'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

/*
 * Labeled Toggle:
 *
 * Usage:
 *
 * <pre>
 * this.toggle = new LabeledToggle({
 *     name: 'type', // allows the toggle to work with formHelper
 *     options: [{
 *         value: 'by-date',
 *         label: 'report.customReport.byDate'
 *     }, {
 *         value: 'relative',
 *         label: 'report.customReport.relative'
 *     }],
 *     value: 'relative', // optional, sets the current value of the toggle
 * 	   escapeLabels: true // optional, escapes the options' labels before rendering
 * })
 *
 * // IMPORTANT: must be in the DOM before rendering
 * this.$('.somewhere').append(this.toggle.el)
 * this.toggle.render()
 * this.toggle.on('change', function(val) {
 *     this.formView.change() // optional, but usually something you want
 *     // any other logic you need
 * }.bind(this))
 * </pre>
 */
var LabeledToggle = Backbone.View.extend({

	className: 'labeled-toggle',

	events: {
		'click .option': '_onClick'
	},

	initialize: function (options) {
		this.options = options || {}
		this.escapeLabels = _.get(this.options, 'escapeLabels', true)
	},

	render: function () {
		const toggleOptions = _.cloneDeep(this.options.options)
		// allow for option labels to be pre-escaped, so we can display things like
		// highlighting in <span>s
		_.forEach(toggleOptions, option => {
			if (!option.label) return

			option.label = i18n.get(option.label)
			if (this.escapeLabels) {
				option.label = _.escape(option.label)
			}
		})

		this.$el.empty().append(template(toggleOptions))

		// make sure something is selected
		var value = this.options.value || this.$('.option').first().data('value')
		this._setValue(value)

		if (this.options.name) {
			this.$el.attr('name', this.options.name)
		}

		this.$el
			.toggleClass('is-full-width', _.result(this.options, 'fullWidth', false))
			.toggleClass('is-small', this.options.isSmall)
		this.$el.data('view', this)

		return this
	},

	// set the value of the toggler, but don't trigger events
	_setValue: function(val) {
		this.$('.option').each(function () {
			$(this).toggleClass('selected', $(this).data('value') == val)
		})

		// Can't properly position the toggle until it's in the DOM, because
		// we need to know the label widths after they've been added to the DOM
		var selected = this.$('.option[data-value=' + val + ']')
		if (_.isEmpty(selected)) {
			var valid = _.join(_.map(this.options.options, 'value'), ', ')
			throw new Error(val + ' isn\'t a valid value.  The valid options are ' + valid)
		}
	},

	/**
	 * Get or sets the value of the toggle
	 * @param {String} [val] if specified, used to change the value of the
	 * toggle. If not specified, calling this method returns the current value
	 * of the toggle
	 * @param {Object} [opt]
	 * @param {Boolean} [opt.silent=true] if false, triggers a 'change' event.
	 * If true, doesn't trigger the event. Defaults to true to match behavior
	 * of other components like the scoreboard-select
	 * @returns {String|undefined} the value of the toggle, if val wasn't specified
	 */
	val: function (val, opt) {
		opt = opt || {}
		let silent = _.isUndefined(opt.silent) ? true : opt.silent

		if (_.isUndefined(val)) {
			return this.$('.selected').data('value')
		}

		if (val == this.val()) {
			return
		}

		this._setValue(val)

		if (!silent) {
			this.trigger('change', val)
		}
	},

	setDisabled: function(disabled) {
		this.disabled = disabled
		this.$el.toggleClass('is-disabled', disabled)
	},

	disableOption: function(value) {
		this.$(`.option[data-value="${value}"]`).addClass('is-disabled')
	},

	_onClick: function (e) {
		if (this.disabled) return

		// Button toggle will select whichever option is clicked
		var val = $(e.currentTarget).data('value')
		this.val(val, { silent: false })
	}

})

export default LabeledToggle

LabeledToggle.__filename__ = 'components/labeled-toggle.js'
